import loadImage from './loadImage.js';
import preloadImages from './preloadImages.js';
export default {
  loadImage,
  preloadImages
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/images/index.js
// module id = 1158
// module chunks = 9